import { useTranslation } from "react-i18next";
import { Button, Typography } from "@material-ui/core";
import { StorageProvider } from "@dashboard-v3/api";

interface PickAgainProps {
  storageProvider: StorageProvider;
  onClick: () => void;
}

export default function PickAgainBtn({
  storageProvider,
  onClick,
}: PickAgainProps) {
  const { t } = useTranslation("copyPolicy");
  const noPickerAvailable = !availableProviders.includes(storageProvider);
  return (
    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
      <Button
        color="primary"
        data-testid="cp-pick-folder-btn"
        disableElevation
        onClick={onClick}
        size="small"
        style={{ alignSelf: "center" }}
        variant="outlined"
        disabled={noPickerAvailable}
      >
        {t("storageFilepath.pickFolder")}
      </Button>
      {noPickerAvailable && (
        <Typography variant="caption" color="error">
          {t("storageFilepath.noPickerAvailable")}
        </Typography>
      )}
    </div>
  );
}

const availableProviders: StorageProvider[] = [
  "BOX",
  "GOOGLEDRIVE",
  "ONEDRIVE",
];
